import { CallState } from '../../types';

export interface WidgetViewRoutingInput {
  callState: CallState;
  isRinging: boolean;
  showACW: boolean;
  agentInAcw: boolean;
  isOutboundCall: boolean;
  pendingContactId: string | null;
  acwLocked: boolean;
  staleLiveCall: boolean;
  isSettingsOpen: boolean;
}

export interface WidgetViewRoutingResult {
  isCallView: boolean;
  isIdleView: boolean;
  effectiveShowACW: boolean;
  isOutboundBootstrap: boolean;
}

const LIVE_CALL_STATUSES = new Set(['ringing', 'connecting', 'active', 'holding']);

export function isLiveCallStatus(status: CallState['status'], isRinging: boolean): boolean {
  return isRinging || LIVE_CALL_STATUSES.has(status);
}

export function isAgentStateSelectorEnabled(status: CallState['status']): boolean {
  return status === 'idle';
}

export function resolveWidgetViews(input: WidgetViewRoutingInput): WidgetViewRoutingResult {
  const hasContact = !!(input.callState.contactId || input.pendingContactId);
  const isLiveCall = isLiveCallStatus(input.callState.status, input.isRinging);

  const isOutboundBootstrap =
    input.isOutboundCall &&
    !hasContact &&
    !input.showACW &&
    !input.agentInAcw &&
    input.callState.status === 'connecting';

  const effectiveShowACW = input.showACW;

  const isCallView =
    (isLiveCall || isOutboundBootstrap) &&
    !effectiveShowACW &&
    !input.acwLocked &&
    !input.staleLiveCall &&
    !input.isSettingsOpen;

  const isIdleView =
    !isCallView &&
    input.callState.status === 'idle' &&
    !input.isRinging &&
    !effectiveShowACW &&
    !input.agentInAcw &&
    !input.isSettingsOpen;

  return {
    isCallView,
    isIdleView,
    effectiveShowACW,
    isOutboundBootstrap,
  };
}
